import * as yup from 'yup';

export const maxFileSize = 75 * 1024;
export const maxFileSizeErrorMessage = '75 MB is the maximum allowed size for each file';
